import React from 'react';
import { Paper, Text, ActionIcon, Tooltip } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import DataTables from 'components/DataTables';
import type { CoursePlanJobFamilyForm } from '../../../../types/lcms/coursePlan';

/* eslint-disable */
interface JobFamilyTableProps {
  dataJobFamilies: CoursePlanJobFamilyForm[];
  onRemove: (jobFamilyId: string) => void;
  mode?: 'add' | 'edit' | 'view';
}
/* eslint-enable */

const JobFamilyTable: React.FC<JobFamilyTableProps> = ({
  dataJobFamilies,
  onRemove,
  mode = 'add'
}) => {
  const columns = [
    {
      heading: 'Job Family',
      active: true,
      props: (row: CoursePlanJobFamilyForm) => (
        <div>
          <Text size='sm' fw={500}>
            {row.jobFamilyName}
          </Text>
          <Text size='xs' c='dimmed'>
            Group: {row.jobFamilyGroupName}
          </Text>
        </div>
      )
    },
    {
      heading: 'Job Family ID',
      active: true,
      props: (row: CoursePlanJobFamilyForm) => (
        <Text size='sm' c='dimmed'>
          {row.jobFamilyId}
        </Text>
      )
    },
    {
      heading: 'Actions',
      active: true,
      props: (row: CoursePlanJobFamilyForm) => (
        <Tooltip label='Remove Job Family'>
          <ActionIcon
            variant='subtle'
            color='red'
            onClick={() => onRemove(row.jobFamilyId)}
            disabled={mode === 'view'}
          >
            <IconTrash size={16} />
          </ActionIcon>
        </Tooltip>
      )
    }
  ];

  if (dataJobFamilies.length === 0) {
    return (
      <Text c='dimmed' size='sm' style={{ fontStyle: 'italic' }}>
        {mode === 'view'
          ? 'No job families assigned to this plan'
          : 'Click "Add Job Families" to select job families (requires Job Family Group selection first)'}
      </Text>
    );
  }

  return (
    <Paper withBorder p={16} radius='lg'>
      <Text fw={500} size='sm' mb={12}>
        Selected Job Families ({dataJobFamilies.length})
      </Text>
      <DataTables
        data={dataJobFamilies}
        columns={columns}
        withPagination={false}
        isNumbering={false}
        loading={false}
      />
    </Paper>
  );
};

export default JobFamilyTable;
